import { gql } from "@apollo/client";

export const QUERY_SAVED_TRUCK_LIST = gql`
  query UserSavedTrucks($orderBy: [String]) {
    userSavedTrucks(orderBy: $orderBy) {
      data {
        id
        originCity
        destinationCity
        originCountry
        destinationCountry
        originZip
        destinationRadius
        originRadius
        destinationZip
        length
        weight
        timeStart
        timeEnd
        details
        linehaulDistance
        duration
        timePosted
        userId
        targetRate
        isDeleted
        user {
          id
          email
          userType
          contactName
          contactEmail
          address
          city
          state
          country
          contactPhone
          mc
          dot
        }
        originRegion {
          id
          originStates
          destinationStates
        }
        destinationRegion {
          id
          originStates
          destinationStates
        }
        trailerTypes {
          id
          loadtypes
          loadChoiceFull
        }
      }
    }
  }
`;

export const MUTATION_DELETE_SAVED_TRUCK = gql`
  mutation DeleteUserSavedTruck($truckId: UUID!) {
    deleteUserSavedTruck(truckId: $truckId) {
      success
    }
  }
`;
